import React, { useEffect, useState } from 'react';
import { Button, Container, List, Modal } from 'semantic-ui-react';
import { TranslationComponent } from '../../TranslationComponent';

export const InstructionsModal: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => setModalOpen(true), 0);
  }, []);

  const handleModalClose = () => setModalOpen(false);

  return (
    <Modal open={modalOpen} onClose={handleModalClose} closeOnDimmerClick={false}>
      <Modal.Header style={{ color: '#E32313' }}>
        <TranslationComponent stringKey={'Regole per la compilazione'} />
      </Modal.Header>
      <Modal.Content>
        <Container style={{ color: '#E32313', marginBottom: '80px' }}>
          <TranslationComponent
            stringKey={
              'Il permesso di lavoro deve essere compilato in linea con quanto previsto dalla Direttiva 001 AZDP per tutte le attività non routinarie ad alto rischio e in ogni caso'
            }
          />
          <List bulleted>
            <List.Item>
              <TranslationComponent stringKey={'per tutte le attività da eseguire in SPAZI CONFINATI'} />
            </List.Item>
            <List.Item>
              <TranslationComponent
                stringKey={'per tutti i lavori di scavo, tranne se lo scavo non è più profondo di 1,2 metri'}
              />
            </List.Item>
            <List.Item>
              <TranslationComponent stringKey={'per tutte le attività sui binari'} />
            </List.Item>
          </List>
        </Container>
        <Container style={{ color: '#062173', marginBottom: '80px' }}>
          <TranslationComponent
            stringKey={
              'Durata massima del PTW EHS: 24 ore. Ciascun permesso di lavoro non può essere valido per più di 24h (per attività che si prolungano su più giorni dovranno essere emessi altrettanti permessi di lavoro: es.3 giorni- 3 permessi di lavoro) Se è previsto l’avvicendamento di più squadre/turni è necessario coinvolgere tutto il personale nella compilazione del PTW EHS dedicato o valutare la compilazione di un ulteriore permesso di lavoro.'
            }
          />
        </Container>
      </Modal.Content>
      <Modal.Actions>
        <Button primary onClick={handleModalClose}>
          <TranslationComponent stringKey={'Accept'} />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
